import NotificationComponent from '../notificationComponent';
import { Notification } from '../../../../types';
import useNotificationsTabPanelStyles from './useNotificationsTabPanelStyles';
/**
 * TabPanelProps interface defines the props for the NotificationsTabPanel component.
 */
interface TabPanelProps {
  index: number;
  value: number;
  notifications: Notification[];
}

/**
 * NotificationsTabPanel component renders the content of a tab panel based on the selected tab.
 */
function NotificationsTabPanel(props: TabPanelProps) {
  const { value, index, notifications } = props;
  const { classes } = useNotificationsTabPanelStyles();
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}>
      {notifications.length > 0 ? (
        notifications.map(notification => (
          <NotificationComponent key={notification._id} notification={notification} />
        ))
      ) : (
        <div className={classes.noNotifications}>No notifications to display.</div>
      )}
    </div>
  );
}

export default NotificationsTabPanel;
